import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import Engine from './components/lib/engine';
import AnimationManager from './components/animationManager';
import {ticker} from './components/common/ticker';


import './index.css';
import App from './App';


const rootElement = document.getElementById('animationroot');
const canvas = document.getElementById('canvas');
canvas.className = 'anim hide';
rootElement.appendChild(canvas);
const engine = new Engine(rootElement);
AnimationManager.canvas = canvas;
AnimationManager.engine = engine;
AnimationManager.ticker = ticker;

engine.initialise().then(initAnimation).catch((error) => {
  console.log(error);
});

/**
 * Initialise the animation.
 */
async function initAnimation() {
  canvas.width = engine.recorder.element.width;
  canvas.height = engine.recorder.element.height;

  canvas.classList.remove('hide');

  ReactDOM.render(
    <Router>
      <App/>
    </Router>,
    document.getElementById('root')
  );
}


